module.exports = __webpack_public_path__ + "static/img/2.310df49.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/2.png
// module id = NKGv
// module chunks = 3